module.exports = __webpack_public_path__ + "img/bca-icon.ec3f6e63.png";